import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material"; 
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useIsMobile from "../Hooks/useIsMobile"; 
import CustomButton from "../components/Button";
import CustomCardList from "../components/Cards";
import PageLoader from "../components/Loader";
import Title from "../components/PageTitle";
import CustomTable from "../components/Table";
import { useToast } from "../components/Toast";
import apiService from "../Services/api.service";
const DoctorsTable = () => {
  const [doctors, setDoctors] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(searchParams.get("q") || "");
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
  const [rowsPerPage, setRowsPerPage] = useState(
    Number(searchParams.get("limit")) || 10
  );
  const [totalCount, setTotalCount] = useState(0); // Total number of doctors (for pagination)
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const [Loader, isLoader] = useState(false);
  const Toast = useToast();
  const auth = localStorage.getItem("token");
  const entityId = localStorage.getItem("entityId");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const updateURLParams = (newFilters) => {
    setSearchParams({
      q: newFilters.searchQuery || "",
      page: newFilters.page || 1,
      limit: newFilters.rowsPerPage || 10,
    });
  };
    useEffect(() => {
      updateURLParams({
        page,
        rowsPerPage,
      });
    }, [page, rowsPerPage]);
    useEffect(() => {
      getDoctors(entityId, page, rowsPerPage);
    }, [page, rowsPerPage]);
    const getDoctors = async (entityId, page, limit) => {
      isLoader(true);
      try {
        // Call API
        const { doctors, totalItems } = await apiService.fetchDoctors(
          auth,
          entityId,
          page,
          limit
        );
        const mappedDoctorss = doctors.map((doc) => ({
          ...doc,
          id: doc.id,
        }));
  
        setDoctors(mappedDoctorss);
        setFilteredDoctors(mappedDoctorss);
        setTotalCount(totalItems);
      } catch (error) {
        Toast.error("Error while Fetching");
      } finally {
        isLoader(false);
      }
    };
  
    useEffect(() => {
      if (typingTimeout) clearTimeout(typingTimeout);
  
      const timeout = setTimeout(async () => {
        try {
          const { doctors, totalItems } = await apiService.fetchDoctors(
            auth,
            entityId,
            page,
            10,
            searchQuery
          );
          const mappedDoctors = doctors.map((doctor) => ({
            ...doctor,
            id: doctor.id,
          }));
          setTotalCount(totalItems);
          setFilteredDoctors(mappedDoctors);
        } catch (error) {
          console.error("Error fetching Kiosk:", error);
          Toast.error("Error while Fetching");
        }
      }, 500); // 500ms debounce
  
      setTypingTimeout(timeout);
  
      // Cleanup
      return () => clearTimeout(timeout);
    }, [searchQuery, page]);
  const handleSearch = (event) => {
    const keyword = event.target.value.toLowerCase();
    setSearchQuery(keyword); // Only set the query
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage + 1); // Set the new page
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10)); // Update rows per page when changed
    setPage(1); // Reset to page 1 when rows per page change
  };
  const formatDate = (dateString) => {
    if (dateString == "NA" || dateString == "Invalid Date") return "NA";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleCardClick = (doctor) => {
    if (location.pathname === "/dashboard/doctor") {
      navigate(`/dashboard/doctor/doctorDetails/${doctor.id}`, {
        state: {
          doctorId: doctor.id,
          doctorName: doctor.name,
          docMobile: doctor.mobile,
          username: doctor.username,
        },
      });
    } else if (location.pathname === "/dashboard/engage") {
      navigate(`/dashboard/engage/doctorDetails/${doctor.id}`, {
        state: {
          doctorId: doctor.id,
          doctorName: doctor.name,
        },
      });
    }
  };
  const handleRowClick = (row) => {
    if (location.pathname === "/dashboard/doctor") {
      navigate(`/dashboard/doctor/doctorDetails/${row.id}`, {
        state: {
          doctorId: row.id,
          doctorName: row.name,
          docMobile: row.mobile,
          username: row.username,
          clinicName:row.clinicName
        },
      });
    } else if (location.pathname === "/dashboard/engage") {
      navigate(`/dashboard/engage/doctorDetails/${row.id}`, {
        state: {
          doctorId: row.id,
          doctorName: row.name,
        },
      });
    }
  };
 
  
  const columns = [
    { field: "name", headerName: "Name", align: "center" },
    { field: "clinicname", headerName: "Clinic", align: "center" },
    
   
  ];

 

  return (
    <div>
      <Paper sx={{ padding: 2 }}>
        <Title text="Doctors" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            marginBottom: 2,
          }}
        >
           
            {/* <CustomButton
              width="200px"
              startIcon={<PersonAddIcon />}
              text="Add Doctor"
              onClick={() => navigate("/dashboard/doctor/add-doctor")}
            /> */}
          
          <TextField
            label="Search"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearch}
            fullWidth
            sx={{ marginBottom: 2, marginTop: 3 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {isMobile ? (
          <CustomCardList
            fields={[
              { label: "Mobile", key: "mobile" },
              { label: "Username", key: "username" },
            ]}
            data={filteredDoctors}
            onCardClick={handleCardClick}
            page={page - 1} // Adjust for zero-based indexing for `CustomTable`
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        ) : (
          <CustomTable
            columns={columns}
            data={filteredDoctors}
            actions={[
              {
                Component: CustomButton,
                props: { text: "Details", width: "90px", height: "40px" },
                onClick: handleRowClick,
              },
            ]}
            page={page - 1} // Adjust for zero-based indexing for `CustomTable`
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        )}
      </Paper>
      {Loader && <PageLoader />}
    </div>
  );
};

export default DoctorsTable;
